"use client";
import { jsx } from "react/jsx-runtime";
import { useLanguage } from "../../../hooks/useLanguage.js";
import { useTracking } from "../../../hooks/useTracking.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Box } from "@mantine/core";
import { forwardRef } from "react";
import TextLink from "../TextLink/TextLink.js";
const _LanguageSelector = forwardRef(
  (props, ref) => {
    var _a;
    const { items, trackingType, polymorphicProps, noIcon, ...rest } = props;
    const { setLanguage, oppositeLang } = useLanguage();
    const tracker = useTracking();
    const oppositeLangLink = items.find((item) => item.code === oppositeLang.code);
    if (!oppositeLangLink) {
      throw Error("Language can't be found");
    }
    const handleClick = (e) => {
      e.preventDefault();
      tracker == null ? void 0 : tracker.page.navigate({
        type: trackingType || "header",
        action: `Skift sprog`,
        destination: oppositeLangLink.href
      });
      setLanguage(oppositeLang.code);
      window.location.href = oppositeLangLink.href;
    };
    return /* @__PURE__ */ jsx(Box, { ...rest, ref, children: /* @__PURE__ */ jsx(
      TextLink,
      {
        weight: 600,
        color: "light",
        variant: "component",
        icon: noIcon ? void 0 : "World",
        iconPlacement: "left",
        onClick: handleClick,
        text: (_a = oppositeLangLink.code) == null ? void 0 : _a.toUpperCase(),
        href: oppositeLangLink.href || "/",
        polymorphicProps
      }
    ) });
  }
);
_LanguageSelector.displayName = "LanguageSelector";
const LanguageSelector = sharedHandler(
  _LanguageSelector
);
LanguageSelector.displayName = _LanguageSelector.displayName;
export {
  LanguageSelector as default
};
